<template>
  <page>
    <div class="main-ct">
      <div class="control-ct">
        <table>
          <tbody>
            <tr>
              <th class="sport-event-label">
                {{
                  $t(
                    'Integrations_Sportradar_Live_Activities_Testing_Tool_Sport_Event'
                  )
                }}
              </th>
              <td class="sport-event-name" @click="copyToClipboard">
                {{ sportEventName }}
              </td>
              <td
                style="cursor: pointer"
                class="sport-event-name"
                @click="copyToClipboard"
              >
                <i class="el-icon-copy-document"></i>
              </td>
            </tr>
          </tbody>
        </table>
        <el-button @click="getReplayFeedAction" type="primary">
          {{ getReplayFeedBtnLabel }}
        </el-button>
      </div>
      <div class="additional-data-ct">
        <div style="display: flex">
          <el-checkbox
            :value="formData.payload.event.inning_half === 'T'"
            :label="
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Top_Of_Inning'
              )
            "
            :disabled="readOnly"
            @change="formData.payload.event.inning_half = 'T'"
          />
          <el-checkbox
            :value="formData.payload.event.inning_half === 'B'"
            :label="
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Bottom_Of_Inning'
              )
            "
            :disabled="readOnly"
            @change="formData.payload.event.inning_half = 'B'"
          />
        </div>
        <div class="tool-container">
          <el-checkbox
            :label="
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Live_Game'
              )
            "
            v-model="formData.payload.event.is_live"
            :disabled="readOnly"
          />
        </div>
        <div class="tool-container">
          <span>
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Event_Type'
              )
            }}
          </span>
          <el-select v-model="formData.payload.event.type" :disabled="readOnly">
            <el-option
              v-for="eventType in eventTypeOptions"
              :key="eventType.value"
              :value="eventType.value"
            />
          </el-select>
        </div>
      </div>
      <div class="additional-data-ct">
        <div style="display:flex; align-items:center; gap:10px">
          <span>{{
            $t('Integrations_Sportradar_Live_Activities_Testing_Tool_Inning')
          }}</span>
          <el-input-number
            v-model="formData.payload.event.inning"
            :min="1"
            :max="99"
            size="medium"
            :disabled="readOnly"
          />
        </div>
        <div style="display:flex; align-items:center; gap:10px">
          <span>{{
            $t('Integrations_Sportradar_Live_Activities_Testing_Tool_Balls')
          }}</span>
          <el-input-number
            v-model="formData.payload.event.count.balls"
            :min="0"
            :max="99"
            size="medium"
            :disabled="readOnly"
          />
        </div>
        <div style="display:flex; align-items:center; gap:10px">
          <span>{{
            $t(
              'Integrations_Sportradar_Live_Activities_Testing_Tool_Strike_Count'
            )
          }}</span>
          <el-input-number
            v-model="formData.payload.event.count.strikes"
            :min="0"
            :max="99"
            size="medium"
            :disabled="readOnly"
          />
        </div>
      </div>
      <div class="team-ct">
        <div style="display:flex; align-items:center; gap:10px">
          <p style="text-align: center">
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Home_Team_Hits'
              )
            }}
          </p>
          <el-input-number
            v-model="formData.payload.event.home_hits"
            :min="0"
            size="medium"
            :disabled="readOnly"
          />
        </div>
        <div style="display:flex; align-items:center; gap:10px">
          <p style="text-align: center">
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Away_Team_Hits'
              )
            }}
          </p>
          <el-input-number
            v-model="formData.payload.event.away_hits"
            :min="0"
            size="medium"
            :disabled="readOnly"
          />
        </div>
        <div style="display:flex; align-items:center; gap:10px">
          <p style="text-align: center">
            {{
              $t('Integrations_Sportradar_Live_Activities_Testing_Tool_Outs')
            }}
          </p>
          <el-input-number
            v-model="formData.payload.event.outs"
            :min="0"
            :max="99"
            size="medium"
            :disabled="readOnly"
          />
        </div>
      </div>
      <div class="team-ct">
        <div class="score-ct">
          <p style="text-align: center">
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Home_Team_Score'
              )
            }}
          </p>
          <el-input-number
            v-model="formData.payload.event.home_score"
            :controls="false"
            :disabled="readOnly"
          />
        </div>
        <div><h1>-</h1></div>
        <div class="score-ct">
          <p style="text-align: center">
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Away_Team_Score'
              )
            }}
          </p>
          <el-input-number
            v-model="formData.payload.event.away_score"
            :controls="false"
            :disabled="readOnly"
          />
        </div>
      </div>
      <div class="event-ct">
        <p style="text-align: center">
          {{
            $t(
              'Integrations_Sportradar_Live_Activities_Testing_Tool_Description'
            )
          }}
        </p>
        <el-input
          style="width: 500px"
          type="textarea"
          :rows="5"
          v-model="formData.payload.event.description"
          :disabled="readOnly"
        />
      </div>
      <div class="runners-ct">
        <h3>
          {{
            $t(
              'Integrations_Sportradar_Live_Activities_Testing_Tool_Runners_Title'
            )
          }}
        </h3>
        <div
          v-for="(runner, index) in formData.payload.event.runners"
          :key="index"
          class="runner-entry"
        >
          <div class="runner-field">
            <label :for="'runner-name-' + index">{{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Runner_Name'
              )
            }}</label>
            <el-input
              :id="'runner-name-' + index"
              v-model="runner.full_name"
              :disabled="readOnly"
              :placeholder="
                $t(
                  'Integrations_Sportradar_Live_Activities_Testing_Tool_Runner_Name_Placeholder'
                )
              "
              size="small"
            />
          </div>
          <div class="runner-field">
            <label :for="'runner-start-' + index">{{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Runner_Start_Base'
              )
            }}</label>
            <el-input-number
              :id="'runner-start-' + index"
              v-model="runner.starting_base"
              :min="0"
              :max="3"
              :disabled="readOnly"
              size="small"
              controls-position="right"
            />
          </div>
          <div class="runner-field">
            <label :for="'runner-end-' + index">{{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Runner_End_Base'
              )
            }}</label>
            <el-input-number
              :id="'runner-end-' + index"
              v-model="runner.ending_base"
              :min="0"
              :max="4"
              :disabled="readOnly"
              size="small"
              controls-position="right"
            />
          </div>
          <div class="runner-field runner-out-field">
            <el-checkbox
              v-model="runner.out"
              :label="
                $t(
                  'Integrations_Sportradar_Live_Activities_Testing_Tool_Runner_Out'
                )
              "
              :disabled="readOnly"
            />
          </div>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click="removeRunner(index)"
            :disabled="readOnly"
            :title="
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Remove_Runner'
              )
            "
          />
        </div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="addRunner"
          :disabled="readOnly || formData.payload.event.runners.length >= 4"
          style="margin-top: 10px;"
        >
          {{
            $t(
              'Integrations_Sportradar_Live_Activities_Testing_Tool_Add_Runner'
            )
          }}
        </el-button>
      </div>
      <div>
        <el-button :disabled="readOnly" type="primary" @click="onSubmit">
          {{ $t('Integrations_Sportradar_Live_Activities_Testing_Tool_Send') }}
        </el-button>
      </div>
    </div>
  </page>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import Page from '@/common/components/page/Page'
import { MlbTestFeed } from '@/modules/integrations/types/sportradar/enum/MlbEventTestFeed'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'MlbLiveActivityTestToolView',

  components: { Page },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    this.createEvent()

    EventBus.$on('integration-status-changed', status => {
      // When activating the integration the value of status is true
      // and deactivating the value of status is false only create a new test event when activating
      if (status) {
        this.createEvent()
      }
    })
  },

  data() {
    return {
      readOnly: false,
      sportEventName: 'mlb-live-activities-test',
      timeOutIds: [],
      MlbTestFeed,
      formData: {
        sport: this.model.params.sport,
        payload: {
          event: {
            home_score: 0,
            away_score: 0,
            type: 'match_started',
            description: 'Match Started',
            inning_half: 'T',
            outs: 0,
            inning: 0,
            home_hits: 0,
            away_hits: 0,
            is_live: true,
            runners: [
              {
                starting_base: 1,
                ending_base: 1,
                out: false,
                full_name: 'José Azócar'
              }
            ],
            count: {
              balls: 0,
              strikes: 0
            }
          }
        },
        params: this.model.params
      },
      eventTypeOptions: [
        {
          value: 'match_started'
        },
        {
          value: 'period_start'
        },
        {
          value: 'score_change'
        },
        {
          value: 'period_end'
        },
        {
          value: 'match_ended'
        },
        {
          value: 'key_period_start'
        },
        {
          value: 'key_period_end'
        },
        {
          value: 'homerun'
        },
        {
          value: 'strikeout'
        },
        {
          value: 'hit'
        },
        {
          value: 'out'
        },
        {
          value: 'strike'
        },
        {
          value: 'walk'
        },
        {
          value: 'pitch'
        }
      ]
    }
  },

  methods: {
    onSubmit() {
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `live-activity/test-send`,
          data: this.formData
        })
      ).then(() => {
        this.$notify({
          title: this.$t(
            'Integrations_Sportradar_Live_Activities_Testing_Tool_Sent_Notification'
          ),
          type: 'success',
          duration: 2000
        })
      })
    },

    async copyToClipboard() {
      await navigator.clipboard.writeText(this.sportEventName).then(() => {
        this.$notify({
          title: this.$t(
            'Integrations_Sportradar_Live_Activities_Testing_Tool_Copied_Notification'
          ),
          type: 'success'
        })
      })
    },

    async replayFeed() {
      await this.replayTestFeed()
      this.readOnly = false
    },

    stopReplayingFeed() {
      this.timeOutIds.forEach(id => {
        clearTimeout(id)
      })
      this.timeOutIds = []
      this.readOnly = false
    },

    replayTestFeed() {
      this.readOnly = true
      return new Promise(resolve => {
        this.MlbTestFeed.forEach((payload, index) => {
          let timeOutId = setTimeout(() => {
            this.formData.payload = payload
            this.onSubmit()
            if (payload.event.type === 'match_ended') {
              resolve()
            }
          }, index * 2000)
          this.timeOutIds.push(timeOutId)
        })
      })
    },

    createEvent() {
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `live-activity/add-test-event`,
          data: {
            sport: this.model.params.sport
          }
        })
      )
    },
    addRunner() {
      if (this.formData.payload.event.runners.length < 4) {
        this.formData.payload.event.runners.push({
          full_name: '',
          starting_base: 0,
          ending_base: 0,
          out: false
        })
      }
    },

    removeRunner(index) {
      this.formData.payload.event.runners.splice(index, 1)
    }
  },

  computed: {
    getReplayFeedAction() {
      return this.readOnly ? this.stopReplayingFeed : this.replayFeed
    },

    getReplayFeedBtnLabel() {
      return this.readOnly
        ? this.$t(
            'Integrations_Sportradar_Live_Activities_Testing_Tool_Stop_Feed'
          )
        : this.$t(
            'Integrations_Sportradar_Live_Activities_Testing_Tool_Replay_Feed'
          )
    }
  },
  watch: {
    'formData.payload.event.type'(newValue) {
      if (newValue === 'match_ended' && this.formData.payload.event.is_live) {
        this.formData.payload.event.is_live = false
        return
      }

      if (!this.formData.payload.event.is_live && newValue !== 'match_ended') {
        this.formData.payload.event.is_live = true
      }
    }
  }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  font-size: 14px;
}

.team-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
}

.event-ct {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 5px;
}

.sport-event-label {
  border: 1px solid #ebeef5;
  padding: 12px 10px;
  background: #fafafa;
  color: #909399;
  font-size: 14px;
}

table {
  border-spacing: 0;
}

.sport-event-name {
  border: 1px solid #ebeef5;
  padding: 12px 10px;
  font-size: 14px;
}

.control-ct {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.score-ct {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.additional-data-ct {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 30px;
}

.runners-ct {
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 15px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.runners-ct h3 {
  margin-top: 0;
  margin-bottom: 10px;
  text-align: center;
  color: #333;
}

.runner-entry {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 10px;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  background-color: #fff;
  flex-wrap: wrap;
}

.runner-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 120px;
  min-width: 120px;
}

.runner-field label {
  font-size: 12px;
  color: #555;
  margin-bottom: 2px;
}

.runner-field .el-input,
.runner-field .el-input-number {
  width: 100%;
}

.runner-field .el-input-number .el-input__inner {
  text-align: left;
}

.runner-out-field {
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  padding-top: 20px;
  min-width: 80px;
}

.runner-entry .el-button--danger {
  margin-left: 10px;
  align-self: center;
}

.runners-ct .el-button[icon='el-icon-plus'] {
  align-self: center;
  width: fit-content;
}

.tool-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

/deep/ .is-checked .el-checkbox__inner {
  background-color: #1d87c8;
  border-color: #1d87c8;
}

/deep/ .el-checkbox.is-bordered.is-checked {
  border-color: #1d87c8;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/sportradar/components/MlbLiveActivityTestToolView.vue